import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ToastService } from "~app/common/components/toast/toast.service";
import { IHandelssortimentModifications, ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { MinaHandelssortimentService } from "../../services/mina-handelssortiment.service";
import { MinaHandelssortimentResultViewModel } from "../mina-handelssortiment-result-view-model";
import { MinaHandelssortimentTexts } from "../mina-handelssortiment.texts";

@Component({
    selector: "rask-mina-handelssortiment-list",
    templateUrl: "./mina-handelssortiment-list.component.html",
    styleUrls: ["./mina-handelssortiment-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective
    ]
})
export class MinaHandlessortimentListComponent implements OnInit {
    handelssortimentModifications: IHandelssortimentModifications[] = [];

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("handelssortimentModifications") hsModifications = new EventEmitter<IHandelssortimentModifications[]>();
    minaHandelssortiment: MinaHandelssortimentResultViewModel[];

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("minaHandelssortimentList") minaHandelssortimentList = new EventEmitter<MinaHandelssortimentResultViewModel[]>();
    texts = MinaHandelssortimentTexts.texts;

    private readonly busyService = inject(BusyService);
    private readonly handelssortimentService = inject(MinaHandelssortimentService);
    private readonly toastService = inject(ToastService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("addedHandelssortiment") set addedSortiment(hs: ISearchHandelssortimentModel[]) {
        if (!hs) {
            return;
        }
        const id = hs[0].id;
        if (this.minaHandelssortiment.filter(item => (item.id === id)).length > 0) {
            this.toastService.add(this.texts.finnsRedan);
        } else {
            const h = hs.map(x => new MinaHandelssortimentResultViewModel(x));
            this.minaHandelssortiment.push(h[0]);
            this.minaHandelssortiment = this.minaHandelssortiment.filter(x => x.id !== -999);
            this.sortAndRefreshMinaHandelssortiment();
            this.setHandelssortimentState(id, "Added");
            this.hsModifications.emit(this.handelssortimentModifications);
            this.minaHandelssortimentList.emit(this.minaHandelssortiment);
        }
    }

    sortAndRefreshMinaHandelssortiment() {
        if (!this.minaHandelssortiment) {
            return;
        }

        this.minaHandelssortiment.sort((a, b) => this.handelssortimentService.orderBy(a.sekvensnummer, b.sekvensnummer)
                || this.handelssortimentService.orderBy(a.namn, b.namn));
    }

    getHandelssortimentToMinaHandelssortiment = () => {
        const query = this.handelssortimentService.getMinaHandelssortiment(false);
        this.busyService.addWork(query).subscribe((result: ISearchHandelssortimentModel[]) => {
            this.minaHandelssortiment = result.map(x => new MinaHandelssortimentResultViewModel(x));
            this.sortAndRefreshMinaHandelssortiment();
            this.minaHandelssortimentList.emit(result.map(x => new MinaHandelssortimentResultViewModel(x)));
        });
    };

    ngOnInit(): void {
        this.getHandelssortimentToMinaHandelssortiment();
    }

    setHandelssortimentState = (id: number, state: "Added" | "Deleted") => {
        const existing = this.handelssortimentModifications.filter(p => p.id === id)[0];
        if (existing) {
            existing.state = state;
        } else {
            this.handelssortimentModifications.push({ id: id,
                state: state });
        }
    };

    removeHandelssortimenFromMinaHandelssortiment = (id: number) => {
        this.minaHandelssortiment = this.minaHandelssortiment.filter(x => x.id !== id);
        this.setHandelssortimentState(id, "Deleted");
        this.hsModifications.emit(this.handelssortimentModifications);
        this.minaHandelssortimentList.emit(this.minaHandelssortiment);
    };
}
